import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from "@angular/core";

@Directive({ standalone: false, selector: "[fxLayoutAlign]" })
export class FxLayoutAlignDirective implements OnChanges {
  @Input() fxLayoutAlign?: string;
  constructor(private readonly host: ElementRef<HTMLElement>, private readonly renderer: Renderer2) {}
  ngOnChanges(_: SimpleChanges): void {
    const [main = "start", cross = "stretch"] = (this.fxLayoutAlign || "").trim().split(/\s+/);
    const mainMap: Record<string, string> = { center: "center", end: "flex-end", "space-around": "space-around", "space-between": "space-between", "space-evenly": "space-evenly" };
    const crossMap: Record<string, string> = { center: "center", end: "flex-end", baseline: "baseline", stretch: "stretch" };
    this.renderer.setStyle(this.host.nativeElement, "display", "flex");
    this.renderer.setStyle(this.host.nativeElement, "justify-content", mainMap[main.toLowerCase()] || "flex-start");
    this.renderer.setStyle(this.host.nativeElement, "align-items", crossMap[cross.toLowerCase()] || "flex-start");
  }
}
